/* eslint-disable max-lines */
import columnTypes from '../columnTypes.js';
import types from '../types.js';

const campaignScope = [
  {
    key: 'arm-campaign-scope-servers',
    name: 'ARM Campaign Scope: Servers',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Server',
        type: types.text,
        tooltip: 'The name of the server',
      },
      {
        source: 'StoragePlatform',
        rename: 'Storage Platform',
        type: types.text,
        tooltip: 'The storage platform of the server',
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      {
        source: 'ReviewStatus',
        rename: 'Review Status',
        type: types.text,
      },
      {
        source: 'ScopeStatus',
        rename: 'In Campaign',
        type: types.text,
        tooltip: 'Is the asset in this campaign?',
      },
      {
        source: 'Notes',
        type: types.text,
        tooltip: 'Notes on the asset within the campaign',
      },
      {
        source: 'Authorizers',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'Email',
        rename: 'Email',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Server ID' }],
  },
  {
    key: 'arm-campaign-scope-groups',
    name: 'ARM Campaign Scope: Groups',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Group Name',
        type: types.text,
      },
      {
        source: 'Domain',
        rename: 'Domain',
        type: types.text,
      },
      {
        source: 'GroupScope',
        rename: 'Scope',
        type: types.text,
      },
      {
        source: 'GroupType',
        rename: 'Type',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      {
        source: 'ReviewStatus',
        rename: 'Review Status',
        type: types.text,
      },
      {
        source: 'ScopeStatus',
        rename: 'In Campaign',
        type: types.text,
        tooltip: 'Is the asset in this campaign?',
      },
      {
        source: 'Notes',
        type: types.text,
        tooltip: 'Notes on the asset within the campaign',
      },
      {
        source: 'Authorizers',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'shortName',
        rename: 'Short Name',
        type: types.text,
      },
      {
        source: 'DistinguishedName',
        rename: 'Distinguished Name',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'Use-Case',
        type: types.text,
      },
      {
        source: 'TotalChildren',
        rename: 'Children',
        type: types.number,
      },
      {
        source: 'NumSubGroups',
        rename: 'Sub-Groups',
        type: types.number,
      },
      {
        source: 'TotalUsers',
        rename: 'Users',
        type: types.number,
      },
      {
        source: 'AdminUsers',
        rename: 'Admin Users',
        type: types.number,
      },
      {
        source: 'RegularUsers',
        rename: 'Regular Users',
        type: types.number,
      },
      {
        source: 'UniqueUsers',
        rename: 'Unique Users',
        type: types.number,
      },
      {
        source: 'SystemAccounts',
        rename: 'System Accounts',
        type: types.number,
      },
      {
        source: 'GroupDepth',
        rename: 'Group Depth',
        type: types.number,
      },
      {
        source: 'SVA',
        rename: 'Stale/Active',
        type: types.text,
      },
      {
        source: 'IsEmpty',
        rename: 'Is Empty',
        type: types.text,
      },
      {
        source: 'CircularReference',
        rename: 'Circular',
        type: types.text,
      },
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor',
        type: types.text,
      },
      {
        source: 'CreateDate',
        rename: 'Create Date',
        type: types.date,
      },
      {
        source: 'ModifyDate',
        rename: 'Modify Date',
        type: types.date,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Group ID' }],
  },
  {
    key: 'arm-campaign-scope-applications',
    name: 'ARM Campaign Scope: Applications',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Application',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      {
        source: 'ReviewStatus',
        rename: 'Review Status',
        type: types.text,
      },
      {
        source: 'ScopeStatus',
        rename: 'In Campaign',
        type: types.text,
        tooltip: 'Is the asset in this campaign?',
      },
      {
        source: 'Notes',
        type: types.text,
        tooltip: 'Notes on the asset within the campaign',
      },
      {
        source: 'Authorizers',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'App ID' }],
  },
  {
    key: 'arm-campaign-scope-accounts',
    name: 'ARM Campaign Scope: Accounts',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Display Name',
        type: types.text,
      },
      {
        source: 'SamAccountName',
        rename: 'Username',
        type: types.text,
      },
      {
        source: 'Domain',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      {
        source: 'ReviewStatus',
        rename: 'Review Status',
        type: types.text,
      },
      {
        source: 'ScopeStatus',
        rename: 'In Campaign',
        type: types.text,
        tooltip: 'Is the asset in this campaign?',
      },
      {
        source: 'Notes',
        type: types.text,
        tooltip: 'Notes on the asset within the campaign',
      },
      {
        source: 'Authorizers',
        type: types.number,
      },
      {
        source: 'PAMr',
        type: types.text,
      },
      {
        source: 'Violations',
        type: types.number,
      },
      {
        source: 'VaultStatus',
        type: types.text,
      },
      {
        source: 'PasswordStatus',
        type: types.text,
      },
      {
        source: 'Scope',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'Status',
        type: types.text,
      },
      {
        source: 'DistinguishedName',
        rename: 'Distinguished Name',
        type: types.text,
      },
      {
        source: 'LastLoginTime',
        rename: 'Last Login',
        type: types.date,
      },
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
      {
        source: 'Servers',
        rename: 'Servers',
        type: types.number,
      },
      {
        source: 'Applications',
        rename: 'Applications',
        type: types.number,
      },
      {
        source: 'Databases',
        rename: 'Database Instances',
        type: types.number,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: '_Id',
        rename: 'Account ID',
      },
      {
        source: 'AccountType',
        rename: 'Type',
        type: types.text,
      },
    ],
  },
  {
    key: 'arm-campaign-scope-collections',
    name: 'ARM Campaign Scope: Collections',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Collection',
        type: types.text,
      },
      {
        source: 'Server',
        type: types.text,
      },
      {
        source: 'HasSensitiveData',
        rename: 'Sensitive Data',
        type: types.text,
        tooltip: 'Does this collection contain sensitive data?',
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      {
        source: 'ReviewStatus',
        rename: 'Review Status',
        type: types.text,
      },
      {
        source: 'ScopeStatus',
        rename: 'In Campaign',
        type: types.text,
        tooltip: 'Is the asset in this campaign?',
      },
      {
        source: 'Notes',
        type: types.text,
        tooltip: 'Notes on the asset within the campaign',
      },
      {
        source: 'Authorizers',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'ServerToRemote',
        rename: 'Server To Remote',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'RiskScore',
        rename: 'Risk Score',
        type: types.number,
      },
      {
        source: 'ServerType',
      },
      {
        source: 'TotalSize',
        rename: 'Size',
        type: types.number,
      },
      {
        source: 'TotalSubfolderCount',
        rename: 'Subfolders',
        type: types.number,
      },
      {
        source: 'TotalOpenFolders',
        rename: 'Open Folders',
        type: types.number,
      },
      {
        source: 'UniqueOpenFolders',
        rename: 'Unique Folders',
        type: types.number,
      },
      {
        source: 'ExcessiveAccess',
        rename: 'Excessive Access',
        type: types.number,
      },
      {
        source: 'FoldersWithDirectUserPermission',
        rename: 'DirectUser',
        type: types.number,
      },
      {
        source: 'FoldersWhereUsersHaveFullControl',
        rename: 'Users Full',
        type: types.number,
      },
      {
        source: 'FoldersWhereGroupsHaveFullControl',
        rename: 'Groups Full',
        type: types.number,
      },
      {
        source: 'MostRecentActivityDate',
        rename: 'Last Activity Date',
        type: types.date,
      },
      {
        source: 'LowRiskInstances',
        rename: 'Low Risk Sensitive',
        type: types.number,
      },
      {
        source: 'MediumRiskInstances',
        rename: 'Medium Risk Sensitive',
        type: types.number,
      },
      {
        source: 'HighRiskInstances',
        rename: 'High Risk Sensitive',
        type: types.number,
      },
      {
        source: 'ReportDate',
        rename: 'Report Date',
        type: types.date,
      },
      {
        source: 'RiskLevel',
        rename: 'Risk Level',
      },
      {
        source: 'EntitlementComplete',
        rename: 'Entitlement Complete',
      },
      {
        source: 'GroupCreation',
        rename: 'Group Creation',
      },
      {
        source: 'GroupPopulation',
        rename: 'Group Population',
      },
      {
        source: 'NotifyOwner',
        rename: 'Notify Owner',
      },
      {
        source: 'Remediated',
        type: types.text,
      },
      {
        source: 'NumberOfObjects',
        rename: '# of Objects',
        type: types.number,
      },
      {
        source: 'AllocatedQuota',
        rename: 'Allocated Quota',
        type: types.number,
      },
      {
        source: 'RemainingQuota',
        rename: 'Available Quota',
        type: types.number,
      },
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
      {
        source: 'DFSPath',
        rename: 'DFS Path',
        type: types.text,
      },
      {
        source: 'LastScannedDate',
        rename: 'Last Scan Date',
        type: types.date,
      },
      {
        source: 'NextScheduledDate',
        rename: 'Next Scheduled Date',
        type: types.date,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Collection ID' }],
  },
  {
    key: 'arm-campaign-scope-approles',
    //key: 'arm-campaign-scope-roles',
    name: 'ARM Campaign Scope: Application Roles',
    [columnTypes.default.key]: [
      { source: 'Name', rename: 'Role', type: types.text },
      { source: 'AppName', rename: 'Application', type: types.text },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      {
        source: 'ScopeStatus',
        rename: 'In Campaign',
        type: types.text,
        tooltip: 'Is the asset in this campaign?',
      },
      {
        source: 'Notes',
        type: types.text,
        tooltip: 'Notes on the asset within the campaign',
      },
      { source: 'Authorizers', type: types.number },
    ],
    [columnTypes.extra.key]: [
      { source: 'Email', type: types.text },
      { source: 'UseCase', rename: 'Use Case', type: types.text },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor', type: types.text },
      { source: 'InstanceName', rename: 'Instance', type: types.text },
      {
        source: 'DatabaseName',
        rename: 'Database Instances',
        type: types.text,
      },
      { source: 'ServerName', rename: 'Server', type: types.text },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Role ID' }],
  },
  {
    key: 'arm-campaign-scope-group policies',
    name: 'ARM Campaign Scope: Group Policies',
    [columnTypes.default.key]: [
      { source: 'Name', rename: 'Policy', type: types.text },
      { source: 'Domain', type: types.text },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      {
        source: 'ScopeStatus',
        rename: 'In Campaign',
        type: types.text,
        tooltip: 'Is the asset in this campaign?',
      },
      {
        source: 'Notes',
        type: types.text,
        tooltip: 'Notes on the asset within the campaign',
      },
      { source: 'Authorizers', type: types.number },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'DistinguishedName',
        rename: 'Distinguished Name',
        type: types.text,
      },
      { source: 'UseCase', rename: 'Use Case', type: types.text },
      { source: 'Email', type: types.text },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
    ],
    [columnTypes.hidden.key]: [
      { source: '_Id', rename: 'Policy ID' },
      { source: 'AccountType', rename: 'Type', type: types.text },
    ],
  },
  {
    key: 'arm-campaign-scope-functions',
    name: 'ARM Campaign Scope: Functions',
    [columnTypes.default.key]: [
      { source: 'Name', rename: 'Function', type: types.text },
      { source: 'AppName', rename: 'Application', type: types.text },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      {
        source: 'ScopeStatus',
        rename: 'In Campaign',
        type: types.text,
        tooltip: 'Is the asset in this campaign?',
      },
      {
        source: 'Authorizers',
        rename: 'Authorizers',
        type: types.number,
      },
      {
        source: 'Notes',
        type: types.text,
        tooltip: 'Notes on the asset within the campaign',
      },
    ],
    [columnTypes.extra.key]: [
      { source: 'Email', type: types.text },
      { source: 'UseCase', rename: 'Use Case', type: types.text },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Function ID' }],
  },
];

const reviewPage = [
  {
    key: 'arm-review-servers',
    name: 'ARM Review Page: Servers',
    [columnTypes.default.key]: [
      {
        source: 'ConfirmOwnershipAndReview',
        rename: 'Confirm Ownership and Review',
        type: types.text,
      },
      { source: 'Name', type: types.text },
      { source: 'StoragePlatform', rename: 'Type', type: types.text },
      { source: 'ProposerName', rename: 'Proposer', type: types.text },
      { source: 'HelpText', rename: 'Ownership Reason', type: types.text },
    ],
    [columnTypes.extra.key]: [
      { source: 'UseCase', rename: 'Use-Case', type: types.text },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
      { source: 'Notes' },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Server ID' }],
  },
  {
    key: 'arm-review-groups',
    name: 'ARM Review Page: Groups',
    [columnTypes.default.key]: [
      {
        source: 'ConfirmOwnershipAndReview',
        rename: 'Confirm Ownership and Review',
        type: types.text,
      },
      { source: 'SamAccountName', type: types.text },
      { source: 'Name', type: types.text },
      { source: 'Scope', type: types.text },
      { source: 'Domain', type: types.text },
      {
        source: 'DistinguishedName',
        rename: 'Distinguished Name',
        type: types.text,
      },
      { source: 'ProposerName', rename: 'Proposer', type: types.text },
      { source: 'HelpText', rename: 'Ownership Reason', type: types.text },
    ],
    [columnTypes.extra.key]: [
      { source: 'shortName', rename: 'Short Name', type: types.text },
      { source: 'TotalChildren', rename: 'Children', type: types.number },
      { source: 'NumSubGroups', rename: 'Subgroups', type: types.number },
      { source: 'TotalUsers', rename: 'Users', type: types.number },
      { source: 'AdminUsers', rename: 'Admin Users', type: types.number },
      { source: 'RegularUsers', rename: 'Regular Users', type: types.number },
      { source: 'UniqueUsers', rename: 'Unique Users', type: types.number },
      {
        source: 'SystemAccounts',
        rename: 'System Accounts',
        type: types.number,
      },
      { source: 'GroupDepth', rename: 'Depth  ', type: types.number },
      { source: 'SVA', rename: 'Group Status', type: types.text },
      { source: 'IsEmpty', rename: 'Is Empty', type: types.number },
      { source: 'CircularReference', rename: 'Circular', type: types.text },
      { source: 'GroupType', rename: 'Type', type: types.text },
      { source: 'UseCase', rename: 'Use-Case', type: types.text },
      { source: 'Email', type: types.text },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
      { source: 'CreateDate', rename: 'Create Date', type: types.date },
      { source: 'ModifyDate', rename: 'Modified Date', type: types.date },
      { source: 'OwnerName', rename: 'Owner', type: types.text },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ManagedBy', rename: 'Managed By', type: types.text },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Notes', type: types.text },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Group ID' }],
  },
  {
    key: 'arm-review-applications',
    name: 'ARM Review Page: Applications',
    [columnTypes.default.key]: [
      {
        source: 'ConfirmOwnershipAndReview',
        rename: 'Confirm Ownership and Review',
        type: types.text,
      },
      { source: 'Name', type: types.text },
      { source: 'ProposerName', rename: 'Proposer', type: types.text },
      { source: 'HelpText', rename: 'Ownership Reason', type: types.text },
    ],
    [columnTypes.extra.key]: [
      { source: 'UseCase', rename: 'Use-Case', type: types.text },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
      { source: 'Notes' },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'App ID' }],
  },
  {
    key: 'arm-review-accounts',
    name: 'ARM Review Page: Accounts',
    [columnTypes.default.key]: [
      {
        source: 'ConfirmOwnershipAndReview',
        rename: 'Confirm Ownership and Review',
        type: types.text,
      },
      { source: 'SamAccountName', type: types.text },
      { source: 'Name', type: types.text },
      { source: 'Domain', type: types.text },
      {
        source: 'DistinguishedName',
        rename: 'Distinguished Name',
        type: types.text,
      },
      { source: 'LastLoginTime', rename: 'Last Login', type: types.date },
      { source: 'ProposerName', rename: 'Proposer', type: types.text },
      { source: 'HelpText', rename: 'Ownership Reason', type: types.text },
      { source: 'Servers', rename: 'Servers', type: types.number },
      { source: 'Applications', rename: 'Applications', type: types.number },
      { source: 'Databases', rename: 'Database Instances', type: types.number },
    ],
    [columnTypes.extra.key]: [
      { source: 'AccountType', rename: 'Account Type', type: types.text },
      { source: 'Status' },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
      { source: 'Notes' },
    ],
    [columnTypes.hidden.key]: [
      { source: 'AccountId', rename: 'Account ID' },
      { source: '_Id', rename: 'AccountStsGuid' },
    ],
  },
  {
    key: 'arm-review-collections',
    name: 'ARM Review Page: Collections',
    [columnTypes.default.key]: [
      {
        source: 'ConfirmOwnershipAndReview',
        rename: 'Confirm Ownership and Review',
        type: types.text,
      },
      { source: 'Name', type: types.text },
      {
        source: 'HasSensitiveData',
        rename: 'Sensitive Data',
        type: types.text,
        tooltip: 'Does this collection contain sensitive data?',
      },
      { source: 'ProposerName', rename: 'Proposer', type: types.text },
      { source: 'HelpText', rename: 'Ownership Reason', type: types.text },
      { source: 'OpenAccess', rename: 'Open Access', type: types.text },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'ServerToRemote',
        rename: 'Server To Remote',
        type: types.text,
      },
      { source: 'ServerType', rename: 'Server Type', type: types.text },
      { source: 'TotalSize', rename: 'Size', type: types.number },
      {
        source: 'TotalSubfolderCount',
        rename: 'Subfolders',
        type: types.number,
      },
      {
        source: 'TotalOpenFolders',
        rename: 'Open Folders',
        type: types.number,
      },
      {
        source: 'UniqueOpenFolders',
        rename: 'Unique Folders',
        type: types.number,
      },
      {
        source: 'ExcessiveAccess',
        rename: 'Excessive Access',
        type: types.number,
      },
      {
        source: 'FoldersWithDirectUserPermission',
        rename: 'Direct User',
        type: types.number,
      },
      {
        source: 'FoldersWhereUsersHaveFullControl',
        rename: 'Users Full',
        type: types.number,
      },
      {
        source: 'FoldersWhereGroupsHaveFullControl',
        rename: 'Groups Full',
        type: types.number,
      },
      {
        source: 'MostRecentActivityDate',
        rename: 'Last Activity Date',
        type: types.date,
      },
      {
        source: 'LowRiskInstances',
        rename: 'Low Risk Sensitive',
        type: types.number,
      },
      {
        source: 'MediumRiskInstances',
        rename: 'Medium Risk Sensitive',
        type: types.number,
      },
      {
        source: 'HighRiskInstances',
        rename: 'High Risk Sensitive',
        type: types.number,
      },
      { source: 'ReportDate', rename: 'Report Date', type: types.date },
      { source: 'RiskLevel', rename: 'Risk Level', type: types.text },
      {
        source: 'EntitlementComplete',
        rename: 'Entitlement Complete',
        type: types.text,
      },
      { source: 'GroupCreation', rename: 'Group Creation', type: types.text },
      {
        source: 'GroupPopulation',
        rename: 'Group Population',
        type: types.text,
      },
      { source: 'NotifyOwner', rename: 'Notify Owner', type: types.text },
      { source: 'Remediated' },
      { source: 'Server' },
      { source: 'NumberOfObjects', rename: '# of Objects', type: types.number },
      { source: 'UseCase', rename: 'Use-Case', type: types.text },
      {
        source: 'ProposedOwnerReason',
        rename: 'Proposed Owner Reason',
        type: types.text,
      },
      {
        source: 'AllocatedQuota',
        rename: 'Allocated Quota',
        type: types.number,
      },
      {
        source: 'RemainingQuota',
        rename: 'Available Quota',
        type: types.number,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
      { source: 'Notes' },
      { source: 'DFSPath', rename: 'DFS Path', type: types.text },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Collection ID' }],
  },
  {
    key: 'arm-review-approles',
    name: 'ARM Review Page: Roles',
    [columnTypes.default.key]: [
      {
        source: 'ConfirmOwnershipAndReview',
        rename: 'Confirm Ownership and Review',
        type: types.text,
      },
      { source: 'Name', type: types.text },
      { source: 'AppName', type: types.text },
      { source: 'ProposerName', rename: 'Proposer', type: types.text },
      { source: 'HelpText', rename: 'Ownership Reason', type: types.text },
    ],
    [columnTypes.extra.key]: [
      { source: 'UseCase', rename: 'Use-Case', type: types.text },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
      { source: 'Notes' },
      { source: 'Server' },
      { source: 'Instance' },
      { source: 'DatabaseName', rename: 'Database', type: types.text },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Role ID' }],
  },
  {
    key: 'arm-review-group policies',
    name: 'ARM Review Page: Group Policies',
    [columnTypes.default.key]: [
      {
        source: 'ConfirmOwnershipAndReview',
        rename: 'Confirm Ownership and Review',
        type: types.text,
      },
      { source: 'Name', type: types.text },
      { source: 'Domain', type: types.text },
      { source: 'LastLoginTime', rename: 'Last Login', type: types.date },
      { source: 'ProposerName', rename: 'Proposer', type: types.text },
      { source: 'HelpText', rename: 'Ownership Reason', type: types.text },
    ],
    [columnTypes.extra.key]: [
      { source: 'AccountType', rename: 'Account Type', type: types.text },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
      { source: 'Notes' },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Policy ID' }],
  },
  {
    key: 'arm-review-functions',
    name: 'ARM Review Page: Functions',
    [columnTypes.default.key]: [
      {
        source: 'ConfirmOwnershipAndReview',
        rename: 'Confirm Ownership and Review',
        type: types.text,
      },
      { source: 'Name', rename: 'Function Name', type: types.text },
      { source: 'AppName', type: types.text },
      { source: 'ProposerName', rename: 'Proposer', type: types.text },
      { source: 'HelpText', rename: 'Ownership Reason', type: types.text },
    ],
    [columnTypes.extra.key]: [
      { source: 'UseCase', rename: 'Use-Case', type: types.text },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
      { source: 'Notes' },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Function ID' }],
  },
  {
    key: 'arm-review-sharepoint',
    name: 'ARM Review Page: SharePoint',
    [columnTypes.default.key]: [
      {
        source: 'ConfirmOwnershipAndReview',
        rename: 'Confirm Ownership and Review',
        type: types.text,
      },
      { source: 'Name', type: types.text },
      { source: 'URL', type: types.text },
      { source: 'ProposerName', rename: 'Proposer', type: types.text },
      { source: 'HelpText', rename: 'Ownership Reason', type: types.text },
    ],
    [columnTypes.extra.key]: [
      { source: 'UseCase', rename: 'Use-Case', type: types.text },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'Notes' },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Site ID' }],
  },
  {
    key: 'arm-review-onedrive',
    name: 'ARM Review Page: OneDrive',
    [columnTypes.default.key]: [
      {
        source: 'ConfirmOwnershipAndReview',
        rename: 'Confirm Ownership and Review',
        type: types.text,
      },
      { source: 'Name', type: types.text },
      { source: 'URL', type: types.text },
      { source: 'ProposerName', rename: 'Proposer', type: types.text },
      { source: 'HelpText', rename: 'Ownership Reason', type: types.text },
    ],
    [columnTypes.extra.key]: [
      { source: 'UseCase', rename: 'Use-Case', type: types.text },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'Notes' },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Drive ID' }],
  },
  {
    key: 'arm-review-teams',
    name: 'ARM Review Page: Teams',
    [columnTypes.default.key]: [
      {
        source: 'ConfirmOwnershipAndReview',
        rename: 'Confirm Ownership and Review',
        type: types.text,
      },
      { source: 'Name', type: types.text },
      { source: 'Channels', rename: '# of Channels', type: types.text },
      { source: 'Members', rename: '# of Members', type: types.text },
      { source: 'ProposerName', rename: 'Proposer', type: types.text },
      { source: 'HelpText', rename: 'Ownership Reason', type: types.text },
    ],
    [columnTypes.extra.key]: [
      { source: 'UseCase', rename: 'Use-Case', type: types.text },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'Notes' },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Team ID' }],
  },
  {
    key: 'arm-complete-table-servers',
    name: 'ARM Review Complete Page: Servers',
    [columnTypes.default.key]: [
      { source: 'Name', type: types.text },
      { source: 'StoragePlatform', rename: 'Type', type: types.text },
      { source: 'UseCase', rename: 'Use Case', type: types.text },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
      { source: 'Notes' },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Server ID' }],
  },
  {
    key: 'arm-complete-table-groups',
    name: 'ARM Review Complete Page: Groups',
    [columnTypes.default.key]: [
      { source: 'SamAccountName', type: types.text },
      { source: 'Name', type: types.text },
      { source: 'Scope', type: types.text },
      { source: 'Domain', type: types.text },
      {
        source: 'DistinguishedName',
        rename: 'Distinguished Name',
        type: types.text,
      },
      { source: 'UseCase', rename: 'Use Case', type: types.text },
    ],
    [columnTypes.extra.key]: [
      { source: 'shortName', rename: 'Short Name', type: types.text },
      { source: 'TotalChildren', rename: 'Children', type: types.number },
      { source: 'NumSubGroups', rename: 'Subgroups', type: types.number },
      { source: 'TotalUsers', rename: 'Users', type: types.number },
      { source: 'AdminUsers', rename: 'Admin Users', type: types.number },
      { source: 'RegularUsers', rename: 'Regular Users', type: types.number },
      { source: 'UniqueUsers', rename: 'Unique Users', type: types.number },
      {
        source: 'SystemAccounts',
        rename: 'System Accounts',
        type: types.number,
      },
      { source: 'GroupDepth', rename: 'Depth', type: types.number },
      { source: 'SVA', rename: 'Group Status', type: types.text },
      { source: 'IsEmpty', rename: 'Is Empty', type: types.number },
      { source: 'CircularReference', rename: 'Circular', type: types.text },
      { source: 'GroupType', rename: 'Type', type: types.text },
      { source: 'Email', type: types.text },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
      { source: 'CreateDate', rename: 'Create Date', type: types.date },
      { source: 'ModifyDate', rename: 'Modified Date', type: types.date },
      { source: 'OwnerName', rename: 'Owner', type: types.text },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ManagedBy', rename: 'Managed By', type: types.text },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      {
        source: 'ProposedOwnerName',
        rename: 'Proposed Owner',
        type: types.text,
      },
      { source: 'Notes', type: types.text },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Group ID' }],
  },
  {
    key: 'arm-complete-table-applications',
    name: 'ARM Review Complete Page: Applications',
    [columnTypes.default.key]: [
      { source: 'Name', type: types.text },
      { source: 'UseCase', rename: 'Use Case', type: types.text },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
      { source: 'Notes' },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'App ID' }],
  },
  {
    key: 'arm-complete-table-accounts',
    name: 'ARM Review Complete Page: Accounts',
    [columnTypes.default.key]: [
      { source: 'SamAccountName', type: types.text },
      { source: 'Name', type: types.text },
      { source: 'Domain', type: types.text },
      {
        source: 'DistinguishedName',
        rename: 'Distinguished Name',
        type: types.text,
      },
      { source: 'LastLoginTime', rename: 'Last Login', type: types.date },
      { source: 'Servers', rename: 'Servers', type: types.number },
      { source: 'Applications', rename: 'Applications', type: types.number },
      { source: 'Databases', rename: 'Database Instances', type: types.number },
    ],
    [columnTypes.extra.key]: [
      { source: 'AccountType', rename: 'Account Type', type: types.text },
      { source: 'Status' },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
      { source: 'Notes' },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Account ID' }],
  },
  {
    key: 'arm-complete-table-collections',
    name: 'ARM Review Complete Page: Collections',
    [columnTypes.default.key]: [
      { source: 'Name', type: types.text },
      {
        source: 'HasSensitiveData',
        rename: 'Sensitive Data',
        type: types.text,
        tooltip: 'Does this collection contain sensitive data?',
      },
      { source: 'OpenAccess', rename: 'Open Access', type: types.text },
      { source: 'UseCase', rename: 'Use-Case', type: types.text },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'ServerToRemote',
        rename: 'Server To Remote',
        type: types.text,
      },
      { source: 'ServerType', rename: 'Server Type', type: types.text },
      { source: 'TotalSize', rename: 'Size' },
      { source: 'TotalSubfolderCount', rename: 'Subfolders' },
      { source: 'TotalOpenFolders', rename: 'Open Folders' },
      { source: 'UniqueOpenFolders', rename: 'Unique Folders' },
      { source: 'ExcessiveAccess', rename: 'Excessive Access' },
      { source: 'FoldersWithDirectUserPermission', rename: 'Direct User' },
      { source: 'FoldersWhereUsersHaveFullControl', rename: 'Users Full' },
      { source: 'FoldersWhereGroupsHaveFullControl', rename: 'Groups Full' },
      {
        source: 'MostRecentActivityDate',
        rename: 'Last Activity Date',
        type: types.date,
      },
      {
        source: 'LowRiskInstances',
        rename: 'Low Risk Sensitive',
        type: types.number,
      },
      {
        source: 'MediumRiskInstances',
        rename: 'Medium Risk Sensitive',
        type: types.number,
      },
      {
        source: 'HighRiskInstances',
        rename: 'High Risk Sensitive',
        type: types.number,
      },
      { source: 'ReportDate', rename: 'Report Date', type: types.date },
      { source: 'RiskLevel', rename: 'Risk Level', type: types.text },
      {
        source: 'EntitlementComplete',
        rename: 'Entitlement Complete',
        type: types.text,
      },
      { source: 'GroupCreation', rename: 'Group Creation', type: types.text },
      {
        source: 'GroupPopulation',
        rename: 'Group Population',
        type: types.text,
      },
      { source: 'NotifyOwner', rename: 'Notify Owner', type: types.text },
      { source: 'Remediated' },
      { source: 'Server' },
      { source: 'NumberOfObjects', rename: '# of Objects', type: types.text },
      {
        source: 'ProposedOwnerReason',
        rename: 'Proposed Owner Reason',
        type: types.text,
      },
      { source: 'AllocatedQuota', rename: 'Allocated Quota' },
      { source: 'RemainingQuota', rename: 'Available Quota' },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
      { source: 'Notes' },
      { source: 'DFSPath', rename: 'DFS Path', type: types.text },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Collection ID' }],
  },
  {
    key: 'arm-complete-table-approles',
    name: 'ARM Review Complete Page: Application Roles',
    [columnTypes.default.key]: [
      { source: 'Name', type: types.text },
      { source: 'AppName', type: types.text },
      { source: 'UseCase', rename: 'Use-Case', type: types.text },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
      { source: 'Notes' },
      { source: 'Server' },
      { source: 'Instance' },
      { source: 'DatabaseName', rename: 'Database', type: types.text },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Role ID' }],
  },
  {
    key: 'arm-complete-table-group policies',
    name: 'ARM Review Complete Page: Group Policies',
    [columnTypes.default.key]: [
      { source: 'Name', type: types.text },
      { source: 'Domain', type: types.text },
      { source: 'LastLoginTime', rename: 'Last Login', type: types.date },
    ],
    [columnTypes.extra.key]: [
      { source: 'AccountType', rename: 'Account Type', type: types.text },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
      { source: 'Notes' },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Policy ID' }],
  },
  {
    key: 'arm-complete-table-functions',
    name: 'ARM Review Complete Page: Functions',
    [columnTypes.default.key]: [
      { source: 'Name', type: types.text },
      { source: 'AppName', type: types.text },
      { source: 'UseCase', rename: 'Use Case', type: types.text },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'SupervisorName', rename: 'Supervisor Name', type: types.text },
      { source: 'Notes' },
      { source: 'HRStatus', rename: 'HR Status', type: types.text },
      { source: 'JobDesc', rename: 'Job Description', type: types.text },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Function ID' }],
  },
  {
    key: 'arm-complete-table-sharepoint',
    name: 'ARM Review Complete Page: SharePoint',
    [columnTypes.default.key]: [
      { source: 'Name', type: types.text },
      { source: 'URL', type: types.text },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'UseCase', rename: 'Use Case', type: types.text },
    ],
    [columnTypes.extra.key]: [
      { source: 'ProposerName', rename: 'Proposer', type: types.text },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'Notes' },
      { source: 'HelpText', rename: 'Ownership Reason', type: types.text },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Site ID' }],
  },
  {
    key: 'arm-complete-table-onedrive',
    name: 'ARM Review Complete Page: OneDrive',
    [columnTypes.default.key]: [
      { source: 'Name', type: types.text },
      { source: 'URL', type: types.text },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'UseCase', rename: 'Use Case', type: types.text },
    ],
    [columnTypes.extra.key]: [
      { source: 'ProposerName', rename: 'Proposer', type: types.text },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'Notes' },
      { source: 'HelpText', rename: 'Ownership Reason', type: types.text },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Drive ID' }],
  },
  {
    key: 'arm-complete-table-teams',
    name: 'ARM Review Complete Page: Teams',
    [columnTypes.default.key]: [
      { source: 'Name', type: types.text },
      { source: 'Channels', rename: '# of Channels', type: types.text },
      { source: 'Members', rename: '# of Members', type: types.text },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'UseCase', rename: 'Use Case', type: types.text },
    ],
    [columnTypes.extra.key]: [
      { source: 'ProposerName', rename: 'Proposer', type: types.text },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      { source: 'Email' },
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department', type: types.text },
      { source: 'Notes' },
      { source: 'HelpText', rename: 'Ownership Reason', type: types.text },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Team ID' }],
  },
  {
    key: 'arm-campaign-scope-sharepoint',
    name: 'ARM Campaign scope Page: SharePoint',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Site Name',
        type: types.text,
      },
      {
        source: 'URL',
        rename: 'Web URL',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      {
        source: 'ScopeStatus',
        rename: 'In Campaign',
        type: types.text,
        tooltip: 'Is the asset in this campaign?',
      },
      {
        source: 'Authorizers',
        rename: 'Authorizers',
        type: types.number,
      },
      {
        source: 'Notes',
        type: types.text,
        tooltip: 'Notes on the asset within the campaign',
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Site ID' }],
  },
  {
    key: 'arm-campaign-scope-onedrive',
    name: 'ARM Campaign scope Page: OneDrive',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Drive Name',
        type: types.text,
      },
      {
        source: 'URL',
        rename: 'Web URL',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      {
        source: 'ScopeStatus',
        rename: 'In Campaign',
        type: types.text,
        tooltip: 'Is the asset in this campaign?',
      },
      {
        source: 'Authorizers',
        rename: 'Authorizers',
        type: types.number,
      },
      {
        source: 'Notes',
        type: types.text,
        tooltip: 'Notes on the asset within the campaign',
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Drive ID' }],
  },
  {
    key: 'arm-campaign-scope-teams',
    name: 'ARM Campaign scope Page: Teams',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Team Name',
        type: types.text,
      },
      {
        source: 'Channels',
        rename: '# of Channels',
        type: types.text,
      },
      {
        source: 'Members',
        rename: '# of Members',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      { source: 'ReviewStatus', rename: 'Review Status', type: types.text },
      {
        source: 'ScopeStatus',
        rename: 'In Campaign',
        type: types.text,
        tooltip: 'Is the asset in this campaign?',
      },
      {
        source: 'Authorizers',
        rename: 'Authorizers',
        type: types.number,
      },
      {
        source: 'Notes',
        type: types.text,
        tooltip: 'Notes on the asset within the campaign',
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'Email',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Team ID' }],
  },
  {
    key: 'arm-campaign-scope-confluence',
    name: 'ARM Campaign Scope Page: Confluence',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Space Name',
        type: types.text,
      },
      {
        source: 'ScopeStatus',
        rename: 'In Campaign',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Owner',
        type: types.text,
      },
      { source: 'OwnershipStatus', rename: 'Ownership Type', type: types.text },
      {
        source: 'OwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      {
        source: 'ReviewStatus',
        rename: 'Review Status',
        type: types.text,
      },
      {
        source: 'IsOpen',
        rename: 'Is Open',
        type: types.text,
      },
      {
        source: 'LastActivityDate',
        rename: 'Last Activity Date',
        type: types.date,
      },
      {
        source: 'Pages',
        rename: 'Pages',
        type: types.number,
      },
      {
        source: 'Authorizers',
        rename: 'Authorizers',
        type: types.number,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Confluence ID' }],
    [columnTypes.extra.key]: [
      {
        source: 'IsExcessive',
        rename: 'Is Excessive',
        type: types.text,
      },
      {
        source: 'Violations',
        rename: 'Violations',
        type: types.number,
      },
      {
        source: 'OpenPages',
        rename: 'Open Pages',
        type: types.number,
      },
      {
        source: 'ExcessivePages',
        rename: 'Excessive Pages',
        type: types.number,
      },
      {
        source: 'StalePages',
        rename: 'Stale Pages',
        type: types.number,
      },
      {
        source: 'Classification',
        rename: 'Classification',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
    ],
  },
  {
    key: 'arm-review-confluence',
    name: 'ARM Review Page: Confluence',
    [columnTypes.default.key]: [
      {
        source: 'ConfirmOwnershipAndReview',
        rename: 'Confirm Ownership and Review',
        type: types.text,
      },
      {
        source: 'Name',
        rename: 'Space Name',
        type: types.text,
      },
      {
        source: 'ProposerName',
        rename: 'Proposer',
        type: types.text,
      },
      {
        source: 'HelpText',
        rename: 'Ownership Reason',
        type: types.text,
      },
      {
        source: 'IsOpen',
        rename: 'Is Open',
        type: types.text,
      },
      {
        source: 'LastActivityDate',
        rename: 'Last Activity Date',
        type: types.date,
      },
      {
        source: 'Pages',
        rename: 'Pages',
        type: types.number,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Confluence ID' }],
    [columnTypes.extra.key]: [
      {
        source: 'UseCase',
        rename: 'Use-Case',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Proposed Owner',
        type: types.text,
      },
      {
        source: 'Email',
        rename: 'Email',
        type: types.text,
      },
      {
        source: 'ReviewStatus',
        rename: 'Review Status',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department',
        type: types.text,
      },
      {
        source: 'Notes',
        rename: 'Notes',
        type: types.text,
      },
      {
        source: 'IsExcessive',
        rename: 'Is Excessive',
        type: types.text,
      },
      {
        source: 'Violations',
        rename: 'Violations',
        type: types.number,
      },
      {
        source: 'OpenPages',
        rename: 'Open Pages',
        type: types.number,
      },
      {
        source: 'ExcessivePages',
        rename: 'Excessive Pages',
        type: types.number,
      },
      {
        source: 'StalePages',
        rename: 'Stale Pages',
        type: types.number,
      },
      {
        source: 'Classification',
        rename: 'Classification',
        type: types.text,
      },
    ],
  },
  {
    key: 'arm-complete-table-confluence',
    name: 'ARM Review Complete Page: Confluence',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Space Name',
        type: types.text,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Proposed Owner Name',
        type: types.text,
      },
      {
        source: 'IsOpen',
        rename: 'Is Open',
        type: types.text,
      },
      {
        source: 'LastActivityDate',
        rename: 'Last Activity Date',
        type: types.date,
      },
      {
        source: 'Pages',
        rename: 'Pages',
        type: types.number,
      },
    ],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Confluence ID' }],
    [columnTypes.extra.key]: [
      {
        source: 'ReviewStatus',
        rename: 'Review Status',
        type: types.text,
      },
      {
        source: 'UseCase',
        rename: 'UseCase',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'Email',
        rename: 'Email',
        type: types.text,
      },
      {
        source: 'Notes',
        rename: 'Notes',
        type: types.text,
      },
      {
        source: 'IsExcessive',
        rename: 'Is Excessive',
        type: types.text,
      },
      {
        source: 'Violations',
        rename: 'Violations',
        type: types.number,
      },
      {
        source: 'OpenPages',
        rename: 'Open Pages',
        type: types.number,
      },
      {
        source: 'ExcessivePages',
        rename: 'Excessive Pages',
        type: types.number,
      },
      {
        source: 'StalePages',
        rename: 'Stale Pages',
        type: types.number,
      },
      {
        source: 'Classification',
        rename: 'Classification',
        type: types.text,
      },
    ],
  },
  {
    key: 'asset-review-step-access-Groups',
    name: 'Access Review Step: Groups',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Name',
        type: types.text,
      },
      {
        source: 'Email',
        rename: 'Email',
        type: types.text,
      },
      {
        source: 'value',
        rename: 'Original Value',
        type: types.text,
      },
      {
        source: 'newValue',
        rename: 'New Value',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'RowNum',
        rename: 'Row Number',
        type: types.text,
      },
      {
        source: 'serverId',
        rename: 'Server Id',
        type: types.text,
      },
      { source: 'STSGuid', rename: 'STS Guid' },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'UserPrincipalName',
        rename: 'User Principal Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
      {
        source: 'JobDesc',
        rename: 'Job Description',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      { source: 'Domain', rename: 'Domain' },
      { source: 'Country', rename: 'Country' },
      { source: 'City', rename: 'City' },
      { source: 'StreetAddr', rename: 'Street Address' },
      { source: 'State', rename: 'State' },
      { source: 'SamAccountName', rename: 'Sam Account Name' },
      { source: 'LastUpdated', rename: 'Last Updated' },
      { source: 'AccountType', rename: 'Account Type' },
      { source: 'ObjectClass', rename: 'Object Class' },
      { source: 'Status', rename: 'Status' },
      { source: 'DeletedDate', rename: 'Deleted Date' },
      { source: 'ADDescription', rename: 'AD Description' },
      { source: 'IsAdmin', rename: 'Is Admin' },
      { source: 'FullName', rename: 'Full Name' },
      { source: 'FirstName', rename: 'FirstName' },
      { source: 'LastName', rename: 'Last Name' },
      { source: 'HRStatus', rename: 'HR Status' },
      { source: 'UserDescription', rename: 'User Description' },
      { source: 'isActive', rename: 'Is Active' },
      { source: 'ImagePath', rename: 'Image Path' },
      { source: 'gender', rename: 'Gender' },
      {
        source: 'PhysicalDeliveryofficeName',
        rename: 'Physical Delivery Office Name',
      },
      { source: 'Info', rename: 'Info' },
      { source: 'CostCenter', rename: 'Cost Center' },
      { source: 'LastLoginTime', rename: 'Last Login Time' },
    ],
  },
  {
    key: 'asset-review-step-access-Functions',
    name: 'Access Review Step: Functions',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Name',
        type: types.text,
      },
      {
        source: 'Email',
        rename: 'Email',
        type: types.text,
      },
      {
        source: 'value',
        rename: 'Original Value',
        type: types.text,
      },
      {
        source: 'newValue',
        rename: 'New Value',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'serverId',
        rename: 'Server Id',
        type: types.text,
      },
      { source: 'STSGuid', rename: 'STS Guid' },
    ],
    [columnTypes.extra.key]: [
      { source: 'ResType', rename: 'Res Type' },
      { source: 'UserName', rename: 'User Name' },
      {
        source: 'UserPrincipalName',
        rename: 'User Principal Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
      {
        source: 'JobDesc',
        rename: 'Job Description',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      { source: 'Domain', rename: 'Domain' },
      { source: 'Country', rename: 'Country' },
      { source: 'City', rename: 'City' },
      { source: 'StreetAddr', rename: 'Street Address' },
      { source: 'State', rename: 'State' },
      { source: 'SamAccountName', rename: 'Sam Account Name' },
      { source: 'LastUpdated', rename: 'Last Updated' },
      { source: 'AccountType', rename: 'Account Type' },
      { source: 'ObjectClass', rename: 'Object Class' },
      { source: 'Status', rename: 'Status' },
      { source: 'DeletedDate', rename: 'Deleted Date' },
      { source: 'ADDescription', rename: 'AD Description' },
      { source: 'IsAdmin', rename: 'Is Admin' },
      { source: 'FullName', rename: 'Full Name' },
      { source: 'FirstName', rename: 'FirstName' },
      { source: 'LastName', rename: 'Last Name' },
      { source: 'HRStatus', rename: 'HR Status' },
      { source: 'UserDescription', rename: 'User Description' },
      { source: 'isActive', rename: 'Is Active' },
      { source: 'ImagePath', rename: 'Image Path' },
      { source: 'gender', rename: 'Gender' },
      {
        source: 'PhysicalDeliveryofficeName',
        rename: 'Physical Delivery Office Name',
      },
      { source: 'Info', rename: 'Info' },
      { source: 'CostCenter', rename: 'Cost Center' },
      { source: 'LastLoginTime', rename: 'Last Login Time' },
    ],
  },
  {
    key: 'asset-review-step-access-Servers',
    name: 'Access Review Step: Servers',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Name',
        type: types.text,
      },
      {
        source: 'Email',
        rename: 'Email',
        type: types.text,
      },
      { source: 'AccessContext', rename: 'Access Context', type: types.text },
      {
        source: 'value',
        rename: 'Original Value',
        type: types.text,
      },
      {
        source: 'newValue',
        rename: 'New Value',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'RowNum',
        rename: 'Row Number',
        type: types.text,
      },
      {
        source: 'serverId',
        rename: 'Server Id',
        type: types.text,
      },
      { source: 'STSGuid', rename: 'STS Guid' },
    ],
    [columnTypes.extra.key]: [
      { source: 'AdminType', rename: 'Admin Type' },
      { source: 'uniqueItemKey', rename: 'Unique Item Key' },
      {
        source: 'UserPrincipalName',
        rename: 'User Principal Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
      {
        source: 'JobDesc',
        rename: 'Job Description',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      { source: 'Domain', rename: 'Domain' },
      { source: 'Country', rename: 'Country' },
      { source: 'City', rename: 'City' },
      { source: 'StreetAddr', rename: 'Street Address' },
      { source: 'State', rename: 'State' },
      { source: 'SamAccountName', rename: 'Sam Account Name' },
      { source: 'LastUpdated', rename: 'Last Updated' },
      { source: 'AccountType', rename: 'Account Type' },
      { source: 'ObjectClass', rename: 'Object Class' },
      { source: 'Status', rename: 'Status' },
      { source: 'DeletedDate', rename: 'Deleted Date' },
      { source: 'ADDescription', rename: 'AD Description' },
      { source: 'IsAdmin', rename: 'Is Admin' },
      { source: 'FullName', rename: 'Full Name' },
      { source: 'FirstName', rename: 'FirstName' },
      { source: 'LastName', rename: 'Last Name' },
      { source: 'HRStatus', rename: 'HR Status' },
      { source: 'UserDescription', rename: 'User Description' },
      { source: 'isActive', rename: 'Is Active' },
      { source: 'ImagePath', rename: 'Image Path' },
      { source: 'gender', rename: 'Gender' },
      {
        source: 'PhysicalDeliveryofficeName',
        rename: 'Physical Delivery Office Name',
      },
      { source: 'Info', rename: 'Info' },
      { source: 'CostCenter', rename: 'Cost Center' },
      { source: 'LastLoginTime', rename: 'Last Login Time' },
    ],
  },
  {
    key: 'asset-review-step-access-Applications',
    name: 'Access Review Step: Applications',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Name',
        type: types.text,
      },
      {
        source: 'Email',
        rename: 'Email',
        type: types.text,
      },
      {
        source: 'value',
        rename: 'Original Value',
        type: types.text,
      },
      {
        source: 'newValue',
        rename: 'New Value',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'RowNum',
        rename: 'Row Number',
        type: types.text,
      },
      {
        source: 'serverId',
        rename: 'Server Id',
        type: types.text,
      },
      { source: 'STSGuid', rename: 'STS Guid' },
    ],
    [columnTypes.extra.key]: [
      { source: 'AdminType', rename: 'Admin Type' },
      { source: 'FilerName', rename: 'Filer Name' },
      {
        source: 'UserPrincipalName',
        rename: 'User Principal Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
      {
        source: 'JobDesc',
        rename: 'Job Description',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      { source: 'Domain', rename: 'Domain' },
      { source: 'Country', rename: 'Country' },
      { source: 'City', rename: 'City' },
      { source: 'StreetAddr', rename: 'Street Address' },
      { source: 'State', rename: 'State' },
      { source: 'SamAccountName', rename: 'Sam Account Name' },
      { source: 'LastUpdated', rename: 'Last Updated' },
      { source: 'AccountType', rename: 'Account Type' },
      { source: 'ObjectClass', rename: 'Object Class' },
      { source: 'Status', rename: 'Status' },
      { source: 'DeletedDate', rename: 'Deleted Date' },
      { source: 'ADDescription', rename: 'AD Description' },
      { source: 'IsAdmin', rename: 'Is Admin' },
      { source: 'FullName', rename: 'Full Name' },
      { source: 'FirstName', rename: 'FirstName' },
      { source: 'LastName', rename: 'Last Name' },
      { source: 'HRStatus', rename: 'HR Status' },
      { source: 'UserDescription', rename: 'User Description' },
      { source: 'isActive', rename: 'Is Active' },
      { source: 'ImagePath', rename: 'Image Path' },
      { source: 'gender', rename: 'Gender' },
      {
        source: 'PhysicalDeliveryofficeName',
        rename: 'Physical Delivery Office Name',
      },
      { source: 'Info', rename: 'Info' },
      { source: 'CostCenter', rename: 'Cost Center' },
      { source: 'LastLoginTime', rename: 'Last Login Time' },
    ],
  },
  {
    key: 'asset-review-step-access-Collections',
    name: 'Access Review Step: Collections',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Name',
        type: types.text,
      },
      {
        source: 'Email',
        rename: 'Email',
        type: types.text,
      },
      {
        source: 'value',
        rename: 'Original Value',
        type: types.text,
      },
      {
        source: 'newValue',
        rename: 'New Value',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'RowNum',
        rename: 'Row Number',
        type: types.text,
      },
      {
        source: 'serverId',
        rename: 'Server Id',
        type: types.text,
      },
      { source: 'STSGuid', rename: 'STS Guid' },
    ],
    [columnTypes.extra.key]: [
      { source: 'AdminType', rename: 'Admin Type' },
      { source: 'FilerName', rename: 'Filer Name' },
      {
        source: 'UserPrincipalName',
        rename: 'User Principal Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
      {
        source: 'JobDesc',
        rename: 'Job Description',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      { source: 'Domain', rename: 'Domain' },
      { source: 'Country', rename: 'Country' },
      { source: 'City', rename: 'City' },
      { source: 'StreetAddr', rename: 'Street Address' },
      { source: 'State', rename: 'State' },
      { source: 'SamAccountName', rename: 'Sam Account Name' },
      { source: 'LastUpdated', rename: 'Last Updated' },
      { source: 'AccountType', rename: 'Account Type' },
      { source: 'ObjectClass', rename: 'Object Class' },
      { source: 'Status', rename: 'Status' },
      { source: 'DeletedDate', rename: 'Deleted Date' },
      { source: 'ADDescription', rename: 'AD Description' },
      { source: 'IsAdmin', rename: 'Is Admin' },
      { source: 'FullName', rename: 'Full Name' },
      { source: 'FirstName', rename: 'FirstName' },
      { source: 'LastName', rename: 'Last Name' },
      { source: 'HRStatus', rename: 'HR Status' },
      { source: 'UserDescription', rename: 'User Description' },
      { source: 'isActive', rename: 'Is Active' },
      { source: 'ImagePath', rename: 'Image Path' },
      { source: 'gender', rename: 'Gender' },
      {
        source: 'PhysicalDeliveryofficeName',
        rename: 'Physical Delivery Office Name',
      },
      { source: 'Info', rename: 'Info' },
      { source: 'CostCenter', rename: 'Cost Center' },
      { source: 'LastLoginTime', rename: 'Last Login Time' },
    ],
  },
  {
    key: 'asset-review-step-access-Roles',
    name: 'Access Review Step: Roles',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Name',
        type: types.text,
      },
      {
        source: 'Email',
        rename: 'Email',
        type: types.text,
      },
      {
        source: 'value',
        rename: 'Original Value',
        type: types.text,
      },
      {
        source: 'newValue',
        rename: 'New Value',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'stsGuid',
        rename: 'sts Guid',
        type: types.text,
      },
      {
        source: 'serverId',
        rename: 'Server Id',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      { source: 'tooltip', rename: 'Tooltip' },
      { source: 'Domain', rename: 'Domain' },
      {
        source: 'Country',
        rename: 'Country',
        type: types.text,
      },
      {
        source: 'City',
        rename: 'City',
        type: types.text,
      },
      {
        source: 'StreetAddr',
        rename: 'Street Address',
        type: types.text,
      },
      {
        source: 'State',
        rename: 'State',
        type: types.text,
      },
      {
        source: 'SamAccountName',
        rename: 'SamAccountName',
        type: types.text,
      },
      { source: 'LastUpdated', rename: 'Last Updated' },
      { source: 'AccountType', rename: 'Account Type' },
      { source: 'ObjectClass', rename: 'Object Class' },
      { source: 'Status', rename: 'Status' },
      { source: 'DeletedDate', rename: 'Deleted Date' },
      { source: 'ADDescription', rename: 'AD Description' },
      { source: 'IsAdmin', rename: 'Is Admin' },
      { source: 'UserPrincipalName', rename: 'User Principal Name' },
      { source: 'FullName', rename: 'Full Name' },
      { source: 'FirstName', rename: 'FirstName' },
      { source: 'LastName', rename: 'Last Name' },
      { source: 'SupervisorName', rename: 'Supervisor Name' },
      { source: 'JobDesc', rename: 'Job Description' },
      { source: 'HRStatus', rename: 'HR Status' },
      { source: 'UserDescription', rename: 'User Description' },
      { source: 'isActive', rename: 'Is Active' },
      { source: 'ImagePath', rename: 'Image Path' },
      { source: 'gender', rename: 'Gender' },
      {
        source: 'PhysicalDeliveryofficeName',
        rename: 'Physical Delivery office Name',
      },
      { source: 'Info', rename: 'Info' },
      {
        source: 'CostCenter',
        rename: 'CostCenter',
      },
      { source: 'BusinessUnit', rename: 'BusinessUnit' },
      { source: 'DepartmentName', rename: 'Department Name' },
      { source: 'LastLoginTime', rename: 'Last Login Time' },
      { source: 'RowNum', rename: 'Row Num' },
      { source: 'ResType', rename: 'ResType' },
      { source: 'UserName', rename: 'User Name' },
    ],
  },
  {
    key: 'asset-review-step-access-SharePoint',
    name: 'Access Review Step: SharePoint',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Name',
        type: types.text,
      },
      {
        source: 'Email',
        rename: 'Email',
        type: types.text,
      },
      {
        source: 'value',
        rename: 'Original Value',
        type: types.text,
      },
      {
        source: 'newValue',
        rename: 'New Value',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'RowNum',
        rename: 'Row Number',
        type: types.text,
      },
      {
        source: 'stsGuid',
        rename: 'stsGuid',
        type: types.text,
      },
      {
        source: 'serverId',
        rename: 'Server Id',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      { source: 'tooltip', rename: 'Tooltip' },
      { source: 'Domain', rename: 'Domain' },
      {
        source: 'Country',
        rename: 'Country',
        type: types.text,
      },
      { source: 'City', rename: 'City' },
      { source: 'StreetAddr', rename: 'Street Address' },
      { source: 'State', rename: 'State' },
      { source: 'SamAccountName', rename: 'Sam Account Name' },
      { source: 'LastUpdated', rename: 'Last Updated' },
      { source: 'AccountType', rename: 'Account Type' },
      { source: 'ObjectClass', rename: 'Object Class' },
      { source: 'Status', rename: 'Status' },
      { source: 'DeletedDate', rename: 'Deleted Date' },
      { source: 'ADDescription', rename: 'AD Description' },
      { source: 'IsAdmin', rename: 'Is Admin' },
      { source: 'UserPrincipalName', rename: 'User Principal Name' },
      { source: 'FullName', rename: 'Full Name' },
      { source: 'FirstName', rename: 'FirstName' },
      { source: 'LastName', rename: 'Last Name' },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
      {
        source: 'JobDesc',
        rename: 'Job Description',
        type: types.text,
      },
      { source: 'HRStatus', rename: 'HR Status' },
      { source: 'UserDescription', rename: 'User Description' },
      { source: 'isActive', rename: 'Is Active' },
      { source: 'ImagePath', rename: 'Image Path' },
      { source: 'gender', rename: 'Gender' },
      {
        source: 'PhysicalDeliveryofficeName',
        rename: 'Physical Delivery Office Name',
      },
      { source: 'Info', rename: 'Info' },
      { source: 'CostCenter', rename: 'Cost Center' },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      { source: 'LastLoginTime', rename: 'Last Login Time' },
      { field: 'ResType', rename: 'Res Type' },
      { field: 'UserName', rename: 'User Name' },
      { field: 'PermDescription', rename: 'Permission Description' },
      { field: 'Permission', rename: 'Permission' },
      { field: 'UniqueID', rename: 'UniqueID' },
      { field: 'EntityType', rename: 'Entity Type' },
    ],
  },
  {
    key: 'asset-review-step-access-OneDrive',
    name: 'Access Review Step: OneDrive',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Name',
        type: types.text,
      },
      {
        source: 'Email',
        rename: 'Email',
        type: types.text,
      },
      { field: 'OneDriveFileName', title: 'File Name' },
      { field: 'OneDriveDirectoryPath', title: 'Directory' },
      { field: 'OneDrivePermission', title: 'Permission' },
      {
        source: 'value',
        rename: 'Original Value',
        type: types.text,
      },
      {
        source: 'newValue',
        rename: 'New Value',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'RowNum',
        rename: 'Row Number',
        type: types.text,
      },
      {
        source: 'stsGuid',
        rename: 'stsGuid',
        type: types.text,
      },
      {
        source: 'serverId',
        rename: 'Server Id',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      { source: 'tooltip', rename: 'Tooltip' },
      { source: 'uniqueItemKey', rename: 'Unique Item Key' },
      { source: 'Domain', rename: 'Domain' },
      {
        source: 'Country',
        rename: 'Country',
        type: types.text,
      },
      { source: 'City', rename: 'City' },
      { source: 'StreetAddr', rename: 'Street Address' },
      { source: 'State', rename: 'State' },
      { source: 'SamAccountName', rename: 'Sam Account Name' },
      { source: 'LastUpdated', rename: 'Last Updated' },
      { source: 'AccountType', rename: 'Account Type' },
      { source: 'ObjectClass', rename: 'Object Class' },
      { source: 'Status', rename: 'Status' },
      { source: 'DeletedDate', rename: 'Deleted Date' },
      { source: 'ADDescription', rename: 'AD Description' },
      { source: 'IsAdmin', rename: 'Is Admin' },
      { source: 'UserPrincipalName', rename: 'User Principal Name' },
      { source: 'FullName', rename: 'Full Name' },
      { source: 'FirstName', rename: 'FirstName' },
      { source: 'LastName', rename: 'Last Name' },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
      {
        source: 'JobDesc',
        rename: 'Job Description',
        type: types.text,
      },
      { source: 'HRStatus', rename: 'HR Status' },
      { source: 'UserDescription', rename: 'User Description' },
      { source: 'isActive', rename: 'Is Active' },
      { source: 'ImagePath', rename: 'Image Path' },
      { source: 'gender', rename: 'Gender' },
      {
        source: 'PhysicalDeliveryofficeName',
        rename: 'Physical Delivery Office Name',
      },
      { source: 'Info', rename: 'Info' },
      { source: 'CostCenter', rename: 'Cost Center' },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      { source: 'LastLoginTime', rename: 'Last Login Time' },
      { field: 'ResType', rename: 'Res Type' },
      { field: 'UserName', rename: 'User Name' },
      { field: 'FileId', rename: 'File Id' },
      { field: 'UniqueID', rename: 'UniqueID' },
      { field: 'EntityType', rename: 'Entity Type' },
      { field: 'Directory', rename: 'Directory' },
      { field: 'Permission', rename: 'Permission' },
      { field: 'FileName', rename: 'File Name' },
      { field: 'fileId', rename: 'file Id' },
    ],
  },
  {
    key: 'asset-review-step-access-Teams',
    name: 'Access Review Step: Teams',
    [columnTypes.default.key]: [
      {
        source: 'Name',
        rename: 'Name',
        type: types.text,
      },
      {
        source: 'Email',
        rename: 'Email',
        type: types.text,
      },
      {
        source: 'value',
        rename: 'Original Value',
        type: types.text,
      },
      {
        source: 'newValue',
        rename: 'New Value',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'RowNum',
        rename: 'Row Number',
        type: types.text,
      },
      {
        source: 'stsGuid',
        rename: 'stsGuid',
        type: types.text,
      },
      {
        source: 'serverId',
        rename: 'Server Id',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      { source: 'tooltip', rename: 'Tooltip' },
      { source: 'Domain', rename: 'Domain' },
      {
        source: 'Country',
        rename: 'Country',
        type: types.text,
      },
      { source: 'City', rename: 'City' },
      { source: 'StreetAddr', rename: 'Street Address' },
      { source: 'State', rename: 'State' },
      { source: 'SamAccountName', rename: 'Sam Account Name' },
      { source: 'LastUpdated', rename: 'Last Updated' },
      { source: 'AccountType', rename: 'Account Type' },
      { source: 'ObjectClass', rename: 'Object Class' },
      { source: 'Status', rename: 'Status' },
      { source: 'DeletedDate', rename: 'Deleted Date' },
      { source: 'ADDescription', rename: 'AD Description' },
      { source: 'IsAdmin', rename: 'Is Admin' },
      { source: 'UserPrincipalName', rename: 'User Principal Name' },
      { source: 'FullName', rename: 'Full Name' },
      { source: 'FirstName', rename: 'FirstName' },
      { source: 'LastName', rename: 'Last Name' },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
      {
        source: 'JobDesc',
        rename: 'Job Description',
        type: types.text,
      },
      { source: 'HRStatus', rename: 'HR Status' },
      { source: 'UserDescription', rename: 'User Description' },
      { source: 'isActive', rename: 'Is Active' },
      { source: 'ImagePath', rename: 'Image Path' },
      { source: 'gender', rename: 'Gender' },
      {
        source: 'PhysicalDeliveryofficeName',
        rename: 'Physical Delivery Office Name',
      },
      { source: 'Info', rename: 'Info' },
      { source: 'CostCenter', rename: 'Cost Center' },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      { source: 'LastLoginTime', rename: 'Last Login Time' },
      { field: 'ResType', rename: 'Res Type' },
      { field: 'UserName', rename: 'User Name' },
      { field: 'UniqueID', rename: 'UniqueID' },
      { field: 'EntityType', rename: 'Entity Type' },
    ],
  },
];

const stepDependencies = [
  {
    key: 'arm-account-dependencies-windows-service',
    name: 'ARM Account Dependencies Windows Service',
    [columnTypes.default.key]: [
      {
        source: 'HostName',
        rename: 'Host Name',
        type: types.text,
      },
      {
        source: 'InstanceName',
        rename: 'Instance Name',
        type: types.text,
      },
      {
        source: 'AccountName',
        rename: 'Account Name',
        type: types.text,
      },
      {
        source: 'ShouldBeOnboarded',
        rename: 'Should Be Onboarded',
        type: types.text,
      },
      {
        source: 'CanRestartService',
        rename: 'Can Restart Service',
        type: types.text,
      },
      {
        source: 'DisableAutomaticManagement',
        rename: 'Disable Automatic Management',
        type: types.text,
      },
      {
        source: 'DisableAutomaticManagementReason',
        rename: 'Disable Automatic Management Reason',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'ServiceTypeId',
        rename: 'Service Type Id',
        type: types.number,
      },
      {
        source: 'ServiceTypeName',
        rename: 'Service Type Name',
        type: types.text,
      },
      {
        source: 'InstanceId',
        rename: 'Instance Id',
        type: types.number,
      },
      {
        source: 'Folder',
        rename: 'Folder',
        type: types.text,
      },
      {
        source: 'AccountSTSGuid',
        rename: 'Account STS Guid',
        type: types.text,
      },
      {
        source: 'TaskFolder',
        rename: 'Task Folder',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [],
  },
  {
    key: 'arm-account-dependencies-iis-application-pool',
    name: 'ARM Account Dependencies IIS Application Pool',
    [columnTypes.default.key]: [
      {
        source: 'HostName',
        rename: 'Host Name',
        type: types.text,
      },
      {
        source: 'InstanceName',
        rename: 'Instance Name',
        type: types.text,
      },
      {
        source: 'AccountName',
        rename: 'Account Name',
        type: types.text,
      },
      {
        source: 'ShouldBeOnboarded',
        rename: 'Should Be Onboarded',
        type: types.text,
      },
      {
        source: 'CanRestartService',
        rename: 'Can Restart Service',
        type: types.text,
      },
      {
        source: 'DisableAutomaticManagement',
        rename: 'Disable Automatic Management',
        type: types.text,
      },
      {
        source: 'DisableAutomaticManagementReason',
        rename: 'Disable Automatic Management Reason',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'ServiceTypeId',
        rename: 'Service Type Id',
        type: types.number,
      },
      {
        source: 'ServiceTypeName',
        rename: 'Service Type Name',
        type: types.text,
      },
      {
        source: 'InstanceId',
        rename: 'Instance Id',
        type: types.number,
      },
      {
        source: 'Folder',
        rename: 'Folder',
        type: types.text,
      },
      {
        source: 'AccountSTSGuid',
        rename: 'Account STS Guid',
        type: types.text,
      },
      {
        source: 'TaskFolder',
        rename: 'Task Folder',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [],
  },
  {
    key: 'arm-account-dependencies-scheduled-task',
    name: 'ARM Account Dependencies Scheduled Task',
    [columnTypes.default.key]: [
      {
        source: 'HostName',
        rename: 'Host Name',
        type: types.text,
      },
      {
        source: 'InstanceName',
        rename: 'Instance Name',
        type: types.text,
      },
      {
        source: 'AccountName',
        rename: 'Account Name',
        type: types.text,
      },
      {
        source: 'ShouldBeOnboarded',
        rename: 'Should Be Onboarded',
        type: types.text,
      },
      {
        source: 'TaskFolder',
        rename: 'Task Folder',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'CanRestartService',
        rename: 'Can Restart Service',
        type: types.text,
      },
      {
        source: 'DisableAutomaticManagement',
        rename: 'Disable Automatic Management',
        type: types.text,
      },
      {
        source: 'DisableAutomaticManagementReason',
        rename: 'Disable Automatic Management Reason',
        type: types.text,
      },
      {
        source: 'ServiceTypeId',
        rename: 'Service Type Id',
        type: types.number,
      },
      {
        source: 'ServiceTypeName',
        rename: 'Service Type Name',
        type: types.text,
      },
      {
        source: 'InstanceId',
        rename: 'Instance Id',
        type: types.number,
      },
      {
        source: 'Folder',
        rename: 'Folder',
        type: types.text,
      },
      {
        source: 'AccountSTSGuid',
        rename: 'Account STS Guid',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [],
  },
];

export default [...campaignScope, ...reviewPage, ...stepDependencies];
